module.exports = __webpack_public_path__ + "img/archive.6efee740.svg";